import React, { useState, useEffect } from 'react';

interface CassetteLogoProps {
  className?: string;
  style?: React.CSSProperties;
  width?: string | number;
  height?: string | number;
}

export default function CassetteLogo(props: CassetteLogoProps) {
  const [svgContent, setSvgContent] = useState<string>('');
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    // Try to load the SVG file
    fetch('/cassette-logo.svg')
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to load logo: ${response.status} ${response.statusText}`);
        }
        return response.text();
      })
      .then(content => {
        setSvgContent(content);
      })
      .catch(error => {
        console.error('Failed to load logo SVG file:', error);
        setError(true);
      });
  }, []);

  if (error) {
    // Show error state - this indicates a bug that needs to be fixed
    return (
      <div 
        className={props.className}
        style={{ 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: props.width || '48px', 
          height: props.height || '32px',
          backgroundColor: '#f3f4f6',
          border: '2px solid #ef4444',
          borderRadius: '4px',
          color: '#ef4444',
          fontSize: '0.625rem',
          ...props.style 
        }}
      >
        LOGO ERROR
      </div>
    );
  }

  if (!svgContent) {
    // Show loading state
    return (
      <div 
        className={props.className}
        style={{ 
          display: 'inline-block',
          width: props.width || '48px', 
          height: props.height || '32px',
          backgroundColor: '#f3f4f6',
          borderRadius: '4px',
          ...props.style 
        }}
      />
    );
  }

  // Create a div with dangerouslySetInnerHTML to render the SVG
  return (
    <div 
      dangerouslySetInnerHTML={{ __html: svgContent }}
      className={props.className}
      style={{ 
        display: 'inline-block',
        width: props.width,
        height: props.height,
        ...props.style 
      }}
    />
  );
} 